<template>
  <b-overlay id="overlay-background" variant="transparent" opacity="1" blur="5px" rounded="lg" :show="isLoading">
    <router-view></router-view>
    <template #overlay>
      <div class="text-center">
        <b-icon icon="x-diamond-fill" font-scale="6" animation="throb" variant="danger"></b-icon>
        <p class="font-weight-bolder text-primary">Please wait...</p>
      </div>
    </template>
  </b-overlay>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isLoading() {
      return this.$store.state.isLoading
    }
  }
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';
</style>
